export const changeSubmitted = (state, val) => {
    state.submitted = val
}
